import { render, staticRenderFns } from "./UpdateFormacoes.vue?vue&type=template&id=ef31524a&scoped=true"
import script from "./UpdateFormacoes.vue?vue&type=script&lang=js"
export * from "./UpdateFormacoes.vue?vue&type=script&lang=js"
import style0 from "./UpdateFormacoes.vue?vue&type=style&index=0&id=ef31524a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef31524a",
  null
  
)

export default component.exports